class SliderPress extends HTMLElement {
  constructor() {
    super();
    this.sliderElement = this.querySelector('[data-slider-thumbs]');
    this.carouselElement = this.querySelector('.press__carousel');  
    this.slider = null;

    if (this.sliderElement) {
      window.addEventListener('resize', debounce(this.initSlider.bind(this), 100));
    }
  }

  connectedCallback() {
    if (this.sliderElement) {
      this.initSlider(); 
    }
  }

  initSlider() {
    if (!this.sliderElement) return;
    if (this.slider !== null) return;

    const autoplaySpeed = this.carouselElement ? parseInt(this.carouselElement.dataset.autoplaySpeed, 10) : undefined;
    const slidesCount = parseInt(this.sliderElement.dataset.slidesCount, 10);
    const perPage = slidesCount > 5 ? 5 : slidesCount;
    const enableAutoplay = this.sliderElement.dataset.autoplay === 'true';

    this.slider = new Splide(this.sliderElement, {
      type: 'loop',
      drag: false,
      pagination: false,
      arrows: false,
      autoplay: enableAutoplay,
      interval: 0, 
      perPage: perPage,
      perMove: 1,
      gap: '2rem',
      speed: autoplaySpeed,
      easing: 'linear',
      rewind: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      updateOnMove: true,
      trimSpace: false,
      live: false,
      isNavigation: false,
      waitForTransition: true,
      resetProgress: false,
      breakpoints: {
        991: {
          perPage: perPage > 3 ? 3 : perPage,
        },
        767: {
          perPage: perPage > 2 ? 2 : perPage,
        }
      }
    }).mount();
  }

  disconnectedCallback() {
    if (this.slider) {
      this.slider.destroy(true);
      this.slider = null;
    }
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

customElements.define('slider-press', SliderPress);